import DropdownOption from "../components/common/DropdownOption";

export default class ChartSeries {
  public idChartSeries: number = 0;
  public idChart: number = 0;
  public seriesColor: string = "";
  public seriesName: string = "";
  public seriesType: string = "";
  public fieldName: string = "";
  public index: number = 0;

  // used on ui only
  public showColorPicker: boolean = false;
  public selectedSeriesTypeOption: DropdownOption<string> | undefined =
    undefined;
  public selectedFieldOption: DropdownOption<string> | undefined = undefined;
}
